import { AgResourceLanguage } from '../types';
import { checkout as EnUsCheckout } from '../en-us/checkout';

export const checkout: AgResourceLanguage['checkout'] = {
  ...EnUsCheckout,
  paymentExpress: {
    title: 'Snelle Afrekening',
    caption: 'of ga hieronder verder om met een creditcard te betalen'
  },
  summaryBlock: {
    title: {
      desktopView: 'Bestellingsoverzicht',
      mobileView: 'Overzicht'
    },
    productsOrderSummary: {
      showProduct: 'Toon Bestellingsoverzicht',
      label: 'Producten',
      hideProduct: 'Verberg Bestellingsoverzicht',
      gift: 'Gratis Cadeau',
      giftPrice: 'Gratis',
      shipsEvery: 'Verzonden elke',
      shipsOneTime: 'Eenmalig verzonden',
      frequencyUnit: 'dagen',
      welcomeKitRemoved: `
        <p>
          Welkom terug!
          <br>Sorry, ons Welkomstpakket is alleen voor nieuwe klanten. Een vervanging nodig? Neem contact op met ons Customer Happiness team.
        </p>
      `
    }
  },
  paymentFields: {
    paymentTitle: 'Betaling',
    paymentReviewTitle: 'Betaling',
    paymentReviewButton: 'Bewerken',
    paymentPageContinueButton: 'Bestelling Beoordelen',
    creditCardLabel: 'Creditcard',
    creditCardReviewText: '{{brand}} eindigend op {{last4}}',
    creditCardCustomError: 'De gegevens van je kaart zijn onvolledig.',
    sepaLabel: 'SEPA Automatische Incasso',
    sepaReviewText: 'SEPA eindigend op {{name}}',
    sepaDisclaimer: `
      Hierbij machtig ik Athletic Greens (EU) Limited om betalingen van mijn rekening te incasseren via automatische incasso.
      In het geval van een abonnement geldt deze machtiging voor herhaalde betalingen.
      Ik geef mijn bank opdracht om automatische incasso's van Athletic Greens (EU) Limited te honoreren.
      Ik ga ermee akkoord dat de termijn voor de wettelijke voorafgaande kennisgeving van de automatische incasso wordt verkort tot één dag.
      Let op: ik kan het geïncasseerde bedrag binnen 8 weken terugvorderen, te beginnen met de respectieve incassodatum.
      De voorwaarden die zijn overeengekomen met mijn bank zijn van toepassing.
    `,
    paymentPageWalletsFields: {
      deleteButton: 'Verwijderen',
      label: 'Betalingsgegevens'
    },
    walletsTotalLabel: 'Totaal'
  },
  shippingFields: {
    subTitle: 'Verzendinformatie',
    caption: 'Je bestelling wordt binnen 3-5 werkdagen verzonden.',
    email: 'E-mail',
    countryRegion: 'Land/regio',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    addressLine1: 'Adres',
    addressLine2: 'Appartement, Suite, Etc',
    city: 'Stad',
    state: 'Provincie',
    zipCode: 'Postcode',
    phone: 'Telefoon',
    pccc: 'PCCC/Paspoortnummer',
    isCreateAccount: 'Blijf toegewijd met tips, inspiratie en community.',
    submitButtonText: 'Ga Verder naar Betaling',
    freeSubmitButtonText: 'Bestelling Beoordelen',
    reviewTitle: 'Verzending',
    reviewButton: 'Bewerken',
    subscribeOnSms: `
      <p>
        <strong>Stuur me een sms wanneer mijn AG1 wordt verzonden en over exclusieve gezondheids- en wetenschapsinhoud.</strong> 
        Ik ga akkoord met het automatisch ontvangen van marketing-sms-berichten van DrinkAG1 op het nummer dat ik hierboven heb opgegeven.
        Toestemming is geen voorwaarde voor aankoop. Berichten- en datakosten kunnen van toepassing zijn. Antwoord HELP of STOP om je af te melden. 
        Bekijk onze <a href="https://drinkag1.com/text-message-terms/" target="_blank" rel="noopener">Sms-voorwaarden</a>, 
        <a href="https://drinkag1.com/privacy/" target="_blank" rel="noopener">Privacybeleid</a> &amp; 
        <a href="https://drinkag1.com/terms-and-conditions/" target="_blank" rel="noopener">Algemene Voorwaarden</a>.
      </p>
    `
  },
  placeOrderFields: {
    continueButton: 'Plaats Bestelling',
    otpCaption: `
      <p>Door deze bestelling te plaatsen, ga je akkoord met de 
        <a href="https://drinkag1.com/terms-and-conditions" target="_blank" rel="noopener">Algemene Voorwaarden</a> 
        en&nbsp;<a href="https://drinkag1.com/privacy" target="_blank" rel="noopener">Privacybeleid</a>.
      </p>
    `,
    subscriptionCaption: `
      <p>
        Door deze bestelling te plaatsen, ga je akkoord met de 
        <a href="https://drinkag1.com/terms-and-conditions" target="_blank" rel="noopener">Algemene Voorwaarden</a> 
        en&nbsp;<a href="https://drinkag1.com/privacy" target="_blank" rel="noopener">Privacybeleid</a>.
        <br><br>
      </p>
      <p>
        Je koopt een doorlopend abonnement. Je machtigt Athletic Greens om elke 30 dagen de betaalmethode op bestand te belasten tegen het dan geldende tarief. Je abonnement wordt elke 30 dagen verlengd
        totdat je het annuleert. Je kunt op elk moment voor je volgende zending annuleren
        door je account te bezoeken of een e-mail te sturen naar <a href="mailto:support@drinkag1.com">support@drinkag1.com</a>.
      </p>
    `
  },
  thanksFields: {
    accountPasswordLabel: 'Wachtwoord',
    minLength: 'Minimaal 8 tekens',
    maxLength: 'Wachtwoord is te lang (maximaal 40 tekens)',
    whitespace: 'Wachtwoord begint of eindigt met spaties',
    uppercase: '1 hoofdletter',
    lowercase: '1 kleine letter',
    number: '1 nummer',
    accountButtonLabelCreate: 'Maak Een Account Aan',
    accountButtonLabelVisit: 'Bezoek Mijn Account',
    accountButtonLabelError: 'Bezoek Mijn Account',
    successMessage: `
      <h1>Welkom bij Fundamentele Voeding, {{customerFirstName}}!</h1>
      <p>Bevestiging is verzonden naar: {{customerEmail}}</p>
    `,
    errorMessage: `
      <h1>Welkom bij AG1</h1>
      <p>Meld je aan om je account te beheren, bestellingen te volgen en exclusieve producten te shoppen.</p>
    `,
    orderDetails: `
      <p><strong>Bestelnummer:</strong> #{{orderId}}</p>
      <p><strong>Geleverd aan:</strong> {{customerName}}</p>
      <p>{{address}}</p></div>
    `,
    accountTitleNotCreated: `
      <h2>Maak Een Account Aan</h2>
      <p>Controleer bestelstatus, volg verzendingen en meer.</p>
    `,
    accountTitleCreated: `
      <h2>Maak Een Account Aan</h2>
      <p>Controleer bestelstatus, volg verzendingen en meer.</p>
    `
  },
  unifiedOrderReview: {
    backButton: 'Terug naar Winkelgedeelte',
    shippingFieldsTitle: 'Verzendinformatie',
    shippingMethodSubTitle: 'Verzendmethode',
    frequencySubTitle: 'Verzendfrequentie',
    frequencyText: 'Elke {{frequency}}',
    frequencyUnit: 'dag',
    paymentTitle: 'Betaling',
    paymentSubTitle: 'Betaalmethode',
    billingAddressSubTitle: 'Factuuradres',
    billingAddressDescription: 'Zelfde als verzendadres',
    placeOrderButton: 'Plaats bestelling',
    commonCaption: `
    <p>
      Je koopt een doorlopend abonnement. Je machtigt Athletic Greens om elke {{order_frequency_days}} dagen de betaalmethode op bestand te belasten tegen het dan geldende tarief.
      Je abonnement wordt elke {{order_frequency_days}} dagen verlengd totdat je het annuleert.
      Je kunt op elk moment voor je volgende zending annuleren door je account te bezoeken of een e-mail te sturen naar <a href="mailto:support@drinkag1.com">support@drinkag1.com</a>.
    </p>
  `,
    giftTitle: 'Verstuur als een cadeau',
    giftRecipientEmailLabel: 'E-mail Ontvanger*',
    giftMessageLabel: 'Cadeaubericht',
    shippingAddressTitle: 'Adresgegevens',
    shippingAddressText: 'Voeg de naam en het adres van de ontvanger toe'
  },
  thanksFieldsMembers: {
    successMessage: `
      <h1>Hoera, je bestelling is binnen!</h1>
      <p>Bevestiging is verzonden naar: {{customerEmail}}</p>
    `,
    successMessageGift: `
      <h1>Hoera, je cadeau bestelling is bevestigd!</h1>
      <p>Een bestelbevestigingsmail is verzonden naar: {{customerEmail}} en {{giftRecipientEmail}}</p>
    `,
    successMessageFreeGift: `
      <h1>Bedankt voor het delen!</h1>
      <p>Bevestigingsmail is verzonden naar: {{customerEmail}} en {{giftRecipientEmail}}</p>
    `,
    orderDetails: `
      <p><strong>Bestelnummer:</strong> #{{orderId}}</p>
      <p><strong>Geleverd aan:</strong> {{customerName}}</p>
      <p>{{address}}</p></div>
    `,
    giftOrderDetails: `
      <p><strong>Bestelnummer:</strong> #{{orderId}}</p>
      <p><strong>Besteltype:</strong> Gratis Pakketten Delen</p>
      <p><strong>Totaal:</strong> {{total}}</p>
      <p><strong>Geleverd aan:</strong> {{customerName}}</p>
      <p>{{address}}</p></div>
      <p>{{email}}</p></div>
    `,
    giftOrderDetailsPaid: `
    <p><strong>Bestelnummer:</strong> #{{orderId}}</p>
    <p><strong>Geleverd aan:</strong> {{customerName}}</p>
    <p><strong>E-mail:</strong> {{email}}</p>
    <p>{{address}}</p></div>
    `,
    viewOrderButtonLabel: 'Bekijk Bestellingsdetails',
    shareMorePacksButtonLabel: 'Deel Meer Pakketten',
    giftMessageTitle: 'Cadeaubericht:'
  },
  // Als Sanity niet werkt
  header: {
    title: 'AFREKENEN',
    editOrder: 'Bestelling Bewerken'
  },
  footer: {
    links: [
      { url: 'https://drinkag1.com/privacy', target: true, text: 'Privacybeleid' },
      {
        url: 'https://drinkag1.com/terms-and-conditions',
        target: true,
        text: 'Algemene Voorwaarden'
      }
    ]
  }
};
